module.exports = __webpack_public_path__ + "img/default-header.d45457fa.png";